/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import styled from "styled-components";
import "./index.css";
import { isMobileOrTablet } from "../Utils/index.js";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";

const NavWrapper = styled.div`
.navbar-dark .navbar-nav .nav-link{
    color: white;
    z-index: 1200;
    // font-weight:600;
    white-space:nowrap;
    text-decoration: none;
}
@media(min-width:992px){
  .navbar-dark .navbar-nav .nav-link{
    margin:0px 2rem;
  }
  .navbar-expand-lg .navbar-nav{
    margin-left:0rem;
  }
}
 
.navbar-expand-lg .navbar-nav .dropdown-menu{
    margin: 0px 0px 0 -30px !important;
}
._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
    font-weight: 600;
}
}
.show>.btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    border-color:white;
}
 
    @media(min-width:992px) and (max-width:1067px){
        .eEKJvu ._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
            font-weight: 600;
            font-size: 14px;
        }
        }
@media(max-width:992px){
.navbar-dark .navbar-toggler{
background-color:#00AAE4;
}
`;

const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();

  let prevScrollPos = window.scrollY;

  window.onscroll = function() {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");

    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };


  return (
    <>
      <div>
        <NavWrapper>
          <Navbar
          id="menuNavbar"
            collapseOnSelect
            expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            className={navbar ? "navbar active" : "navbar"}
          >
            <Container className="headerscotin">
            <Navbar.Brand className="">
              
              <div className="d-flex">
                <div>
                  <a
                    href={"https://www.swmc.com/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={"SWMC-Logo"}
                  >
                    <img
                      src={"https://resources.swmc.com/swmc-react-2025/home-page/sunwest-logo-blue.svg"}
                      className="main_logo"
                      alt={"SWMCLogo"}
                    />
                  </a>
                  
                </div>
           
                <UserWayAccessibilityMenu color="black" width={40} height={40} />
              
              </div>
              
            </Navbar.Brand>
            </Container>
          </Navbar>
        </NavWrapper>
      </div>
    </>
  );
};

export default HeaderNavbar;